<template>
    <div>

        <div class="row">
            <div class="col-md-8">
                <div class="row">
                    <div class="col-md-2">
                        <img src="/img/icons/aste_icon.svg" class="img-fluid">
                    </div>
                    <div class="col-md-10">
                        <div class="card  abtg__default-card abtg__default-card-border">
                            <div class="card-head">
                                <header>{{$t('operation.title_card')}}</header>
                                <div class="abtg__header_popover">
                                    <popover module="custom" content="buildingData" color="grey"
                                             position="right"></popover>
                                </div>

                                <div class="tools" style="margin-bottom: 0 !important;">
                                    <a @click="closeOrOpen()">
                                        <button class="btn btn-default  shadow-none abtg__btn-tool">
                            <span v-if="!closedOperation">
                            <i
                                    class="fas fa-lock-open"></i> In corso
                            </span>
                                            <span v-else>
                            <i
                                    class="fas fa-lock"></i> conclusa
                           </span>
                                        </button>

                                    </a>
<!--                                    <a @click="openModalBuilding()"-->
<!--                                       class="btn btn-default abtg__btn-star shadow-none abtg__btn-tool">-->

<!--                                        Modifica-->


<!--                                    </a>-->


                                </div>
                            </div>
                            <div class="card-body ">

                                <p><span class="  abtg__text-abtg">{{$t('auction.label_city')}}:</span> <strong><span
                                        class="abtg__color-black-label">{{formData.city}}</span></strong><br>

                                    <span class="  abtg__text-abtg">{{$t('auction.label_rge')}}:</span> <strong><span
                                            class="abtg__color-black-label">{{formData.rge}}</span></strong><br>

                                    <span class="  abtg__text-abtg">{{$t('auction.label_ctu')}}:</span> <strong><span
                                            class="abtg__color-black-label">{{formData.valore_ctu}}</span></strong><br>


                                </p>
                                <hr class="abtg__hr-narrow">

                                <div class="row">
                                    <div class="col-md-9">
                                        <p><span class="abtg__label-small">{{$t('auction.label_address')}}</span><br>
                                            <strong><span
                                                    class="abtg__color-black-label">{{formData.indirizzo}}</span></strong>
                                        </p>
                                    </div>

                                    <div class="col-lg-3">

                                        <p><span
                                                class="abtg__label-small">{{$t('auction.label_auction_date')}}</span><br><strong><span
                                                class="abtg__color-black-label">{{formData.data_asta}}</span></strong>
                                        </p>

                                    </div>


                                </div>

                                <hr class="abtg__hr-narrow">

                                <div class="row">
                                    <div class="col-lg-3">
                                        <p><span class="abtg__label-small">Mq</span><br><strong><span
                                                class="abtg__color-black-label">{{formData.mq}}</span></strong></p>
                                    </div>

                                    <div class="col-lg-3"><p><span
                                            class="abtg__label-small">N. incanto</span><br><strong><span
                                            class="abtg__color-black-label">{{formData.n_incanto}}</span></strong></p>
                                    </div>
                                    <div class="col-lg-3">


                                        <p><span class="abtg__label-small">Base Asta</span><br>
                                            <strong><span
                                                    class="abtg__color-black-label">{{formData.base_asta}}</span></strong>
                                        </p>

                                    </div>
                                    <div class="col-lg-3">
                                        <p><span
                                                class="abtg__label-small">{{$t('auction.label_minimum_offer')}}</span><br>
                                            <strong><span
                                                    class="abtg__color-black-label">{{formData.offerta_minima}}</span></strong>
                                        </p>
                                    </div>


                                </div>

                                <hr class="abtg__hr-narrow">

                                <div class="row">
                                    <div class="col-lg-3">
                                        <p><span
                                                class="abtg__label-small">{{$t('auction.label_cadastral_income')}}</span><br>
                                            <strong><span
                                                    class="abtg__color-black-label">{{formData.rendita_catastale}}</span></strong>
                                        </p>
                                    </div>

                                    <div class="col-lg-3">
                                        <p><span class="abtg__label-small">{{$t('auction.label_building_value')}}</span><br>
                                            <strong><span
                                                    class="abtg__color-black-label">{{formData.valore_immobiliare_it}}</span></strong>
                                        </p>
                                    </div>

                                    <div class="col-lg-3"><p>
                                        <span class="abtg__label-small">{{$t('auction.label_borsino_value')}}</span><br>
                                        <strong><span
                                                class="abtg__color-black-label">{{formData.valore_borsino_immobiliare}}</span></strong>
                                    </p></div>

                                    <div class="col-lg-3">
                                        <p><span
                                                class="abtg__label-small">{{$t('auction.label_street_price')}}</span><br><strong><span
                                                class="abtg__color-black-label">{{formData.street_price}}</span></strong>
                                        </p></div>


                                </div>


                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="col-md-4">
                <div class="row">
                    <div class="col">
                        <div class="card abtg__default-card abtg__default-card-border">
                            <div class="card-head ">
                                <div class="abtg__small-card-header"><i class="fas fa-circle"></i> <span
                                        class="abtg__small-card-label">ROI</span></div>
                            </div>
                            <div class="card-body no-padding ">
                                <div class="abtg__card-text-number" v-if="consumptive_roi">{{consumptive_roi}}%</div>
                                <div class="progress">
                                    <div class="progress-bar" style="width:100%;"></div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="card abtg__default-card abtg__default-card-border">
                            <div class="card-head ">
                                <div class="abtg__small-card-header"><i class="fas fa-circle"></i> <span
                                        class="abtg__small-card-label">ROE</span></div>
                            </div>
                            <div class="card-body no-padding ">
                                <div class="abtg__card-text-number" v-if="consumptive_roe">{{consumptive_roe}}%</div>
                                <div class="progress">
                                    <div class="progress-bar" style="width:100%;"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <div class="card abtg__default-card abtg__default-card-border">

                            <div class="card-body no-padding ">
                                <p><span class="abtg__label-small">Note</span><br>
                                    <span class="abtg__label-small-text">{{formData.note}}</span>
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!--old -->

    </div>
</template>
<script>
    import {mixin} from '../../../helpers/helper'
    import {Money} from 'v-money';
    import {createHelpers} from 'vuex-map-fields';
    import Popover from '../../commons/popover';

    const {mapFields} = createHelpers({
        getterType: 'auction/getField',
        mutationType: 'auction/updateField',
    });

    export default {
        mixins: [mixin],
        components: {Money, Popover},
        props: ['page'],
        data: function () {
            return {}
        },

        computed: {
            ...mapFields(['formData', 'incomeData', 'closedOperation', 'auctionId']),
            consumptive_roi: function () {
                return this.$store.state.custom.roi_;
            },
            consumptive_roe: function () {
                return this.$store.state.custom.roe_;
            }
        },
        created: function () {
            this.getAuction();
            this.retrieveIncome();
            this.addTeamToOperation();
        },
        methods: {
            //editAuction

            getAuction: function () {
                this.$store.dispatch('auction/readingAuction', this.page);
                //this.$store.dispatch('auction/readingIncome', this.page);
            },

            openModalBuilding: function () {
                this.$store.dispatch('auction/editAuction', this.page, {root: true});
                this.$store.state.auction.triggerForAuctionIncome = true;
            },

            retrieveIncome: function () {
                this.$store.dispatch('custom/settingIncomeForAuction', {auctionId: this.page}, {root: true});
            },

            addTeamToOperation: function()
            {
                this.$store.dispatch('custom/addTeamToOperation', {resourceId: this.page, type: 2}, {root: true});
            },

            closeOrOpen: function () {
                this.auctionId = this.page;
                this.$store.dispatch('auction/closeOrOpen');
            }
        }
    }

</script>
